// Generated by Melange

import * as Belt__Belt_List from "melange.belt/belt_List.js";
import * as Buhta_cabinet__Button from "../../components/html/Button.js";
import * as Buhta_cabinet__Field from "../../components/html/Field.js";
import * as Buhta_cabinet__FormView from "../../components/html/FormView.js";
import * as Buhta_cabinet__PhoneField from "../../components/html/PhoneField.js";
import * as Buhta_components__Text from "../../../../../packages/components/src/html/Text.js";
import * as Buhta_components__ToastContainer from "../../../../../packages/components/src/moleculas/ToastContainer.js";
import * as Buhta_conf__Config from "../../../../../packages/conf/lib/Config.js";
import * as Caml_array from "melange.js/caml_array.js";
import * as Cn from "../../../../../vendored/classnames/Cn.js";
import * as Curry from "melange.js/curry.js";
import * as Formating from "../../../../../packages/util/lib/Formating.js";
import * as StaticAsset from "../../../../../packages/util/lib/StaticAsset.js";
import * as Stdlib__Array from "melange/array.js";
import * as Stdlib__List from "melange/list.js";
import * as React from "react";
import * as JsxRuntime from "react/jsx-runtime";

function RecoveryForm(Props) {
  let payload = Props.payload;
  const cfg = Buhta_conf__Config.getConfig(undefined);
  const env = cfg.app_env;
  const match = React.useState(function () {
        
      });
  const setToast = match[1];
  const match$1 = React.useState(function () {
        return "";
      });
  const setEmail = match$1[1];
  const match$2 = React.useState(function () {
        return "";
      });
  const setPhone = match$2[1];
  const phone = match$2[0];
  const match$3 = React.useState(function () {
        return "email";
      });
  const match$4 = React.useState(function () {
        return [];
      });
  const setClosures = match$4[1];
  const closures = match$4[0];
  const messages = payload !== undefined && !(typeof payload === "string" || payload.NAME !== "AuthLoginPayload") ? payload.VAL.messages : /* [] */0;
  const emailSent = Stdlib__List.length(messages) > 0 && Stdlib__List.hd(messages) === "An email containing a recovery link has been sent to the email address you provided.";
  const errors = payload !== undefined && !(typeof payload === "string" || payload.NAME !== "AuthLoginPayload") ? payload.VAL.errors : /* [] */0;
  React.useEffect((function () {
          Curry._1(setClosures, (function (param) {
                  return Stdlib__Array.init(Stdlib__List.length(errors), (function (param) {
                                return false;
                              }));
                }));
        }), [errors]);
  const initialFocusRef = React.useRef(null);
  let tmp;
  let exit = 0;
  if (payload !== undefined && !(typeof payload === "string" || payload.NAME !== "AuthLoginPayload")) {
    const payload$1 = payload.VAL;
    const __x = payload$1.errors;
    tmp = JsxRuntime.jsxs(React.Fragment, {
          children: [
            Belt__Belt_List.toArray(Belt__Belt_List.mapWithIndex(__x, (function (index, error) {
                        const Key = "error-" + String(index);
                        return JsxRuntime.jsx("div", {
                                    children: JsxRuntime.jsxs("div", {
                                          children: [
                                            JsxRuntime.jsx(Buhta_components__Text.PSmall.make, {
                                                  className: "ml-4 text-white",
                                                  children: error
                                                }),
                                            JsxRuntime.jsx("button", {
                                                  children: JsxRuntime.jsx("img", {
                                                        src: StaticAsset.src("/static/icons/close-circle-white.svg")
                                                      }),
                                                  className: "border-l border-white-24 ml-3 p-2",
                                                  onClick: (function (param) {
                                                      Curry._1(setClosures, (function (param) {
                                                              return Stdlib__Array.mapi((function (i, param) {
                                                                            return i === index;
                                                                          }), closures);
                                                            }));
                                                    })
                                                })
                                          ],
                                          className: Cn.fromList({
                                                hd: "bg-alert border border-alert-16 rounded flex items-center",
                                                tl: {
                                                  hd: Cn.on("hidden", closures.length !== 0 && Caml_array.get(closures, index)),
                                                  tl: /* [] */0
                                                }
                                              })
                                        }),
                                    className: "fixed z-10 w-screen left-0 top-32 flex justify-center"
                                  }, Key);
                      }))),
            emailSent ? JsxRuntime.jsxs("div", {
                    children: [
                      JsxRuntime.jsx(Buhta_components__Text.H2.make, {
                            children: "Проверьте почту"
                          }),
                      JsxRuntime.jsx(Buhta_components__Text.PSmall.make, {
                            className: "mt-2 text-gray-medium",
                            children: "Отправили письмо со ссылкой на восстановление пароля."
                          }),
                      JsxRuntime.jsx(Buhta_components__Text.PSmall.make, {
                            className: "mt-2 text-gray-medium",
                            children: "Не забудьте проверить папку со Спамом."
                          })
                    ],
                    className: "bg-white rounded-md shadow p-10"
                  }) : JsxRuntime.jsxs("div", {
                    children: [
                      JsxRuntime.jsxs(Buhta_components__Text.H4.make, {
                            className: "text-center relative",
                            children: [
                              JsxRuntime.jsx("a", {
                                    children: JsxRuntime.jsx("img", {
                                          src: StaticAsset.src("/static/icons/arrow-back-24.svg")
                                        }),
                                    className: "absolute left-4",
                                    href: env === "production" ? "https://id.buhta.com/login" : "https://id.sandbox.buhta.com/login"
                                  }),
                              "Восстановление пароля"
                            ]
                          }),
                      JsxRuntime.jsx("hr", {
                            className: "mt-3"
                          }),
                      JsxRuntime.jsx("div", {
                            children: JsxRuntime.jsxs(Buhta_cabinet__FormView.make, {
                                  onSubmit: (function (param) {
                                      
                                    }),
                                  initialFocusRef: initialFocusRef,
                                  action: payload$1.action,
                                  method_: "POST",
                                  children: [
                                    JsxRuntime.jsx("input", {
                                          name: "csrf_token",
                                          type: "hidden",
                                          value: payload$1.csrfToken
                                        }),
                                    match$3[0] === "email" ? JsxRuntime.jsx(Buhta_cabinet__Field.make, {
                                            label: "Email",
                                            type_: "email",
                                            name: "email",
                                            required: true,
                                            onChange: (function (value) {
                                                Curry._1(setEmail, (function (param) {
                                                        return value;
                                                      }));
                                              }),
                                            inputRef: initialFocusRef,
                                            value: match$1[0]
                                          }) : JsxRuntime.jsxs(React.Fragment, {
                                            children: [
                                              JsxRuntime.jsx("input", {
                                                    name: "phone",
                                                    type: "hidden",
                                                    value: Formating.formatPhone(phone)
                                                  }),
                                              JsxRuntime.jsx(Buhta_cabinet__PhoneField.make, {
                                                    value: Formating.formatPhone(phone),
                                                    onChange: (function (value) {
                                                        Curry._1(setPhone, (function (param) {
                                                                return value;
                                                              }));
                                                      }),
                                                    required: true
                                                  })
                                            ]
                                          }),
                                    JsxRuntime.jsx(Buhta_cabinet__Button.make, {
                                          kind: "primary",
                                          name: "method",
                                          value: "link",
                                          type_: "submit",
                                          className: "mt-6",
                                          isWide: true,
                                          children: "Продолжить"
                                        })
                                  ]
                                }),
                            className: "p-6 sm:p-10"
                          })
                    ],
                    className: "bg-white rounded-md shadow pt-3"
                  })
          ]
        });
  } else {
    exit = 1;
  }
  if (exit === 1) {
    tmp = JsxRuntime.jsx(Buhta_components__Text.PSmall.make, {
          children: "couldn't parse the payload"
        });
  }
  return JsxRuntime.jsx(Buhta_components__ToastContainer.make, {
              toast: match[0],
              onExpired: (function (param) {
                  Curry._1(setToast, (function (param) {
                          
                        }));
                }),
              children: tmp
            });
}

const make = RecoveryForm;

export {
  make ,
}
/* Buhta_cabinet__Button Not a pure module */
